import axios from 'axios';

// Request interceptors

axios.interceptors.request.use(config => {
  const newParams = { params: { ...config.params, client: 'web-ui-chat' } };
  return { ...config, ...newParams };
}, error => Promise.reject(error));
